"use strict";
(self["webpackChunktom_bihn"] = self["webpackChunktom_bihn"] || []).push([[3782],{

/***/ 3782:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ stickyATC)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function stickyATC({ wrapper }) {
  const { classes } = window.config

  const selectors = {
    form: 'form[action="/cart/add"]',
    footer: '#shopify-section-footer',
  }

  const cache = {
    $form: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).closest(selectors.form),
    $footer: jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).find(selectors.footer),
  }

  let formIsVisible = false
  let footerIsVisible = false

  ;(function init() {
    watchForForm()
    watchForFooter()
  })()

  function watchForForm() {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          formIsVisible = true
        } else {
          formIsVisible = false
        }
        toggleVisibility()
      })
    })

    observer.observe(cache.$form[0])
  }

  function watchForFooter() {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          footerIsVisible = true
        } else {
          footerIsVisible = false
        }
        toggleVisibility()
      })
    })

    observer.observe(cache.$footer[0])
  }

  function toggleVisibility() {
    // Show when form is not visible and footer is not visible
    const shouldShow = !formIsVisible && !footerIsVisible
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).toggleClass(classes.active, shouldShow)
  }
}

/***/ })

}]);